import type { CityConfig } from "../city-template/types";

export const decaturILConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  city: "Decatur",
  state: "Illinois",
  stateAbbr: "IL",
  slug: "decatur-il",
  route: "/cities/decatur-il",
  title: "Emergency Passport Decatur, IL — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency passport and expedited passport services in Decatur, Illinois — as fast as 24 hours. Fast passport renewal for ADM corporate travelers, Millikin University faculty, and all Macon County residents. A+ BBB rated registered State Dept. courier serving Central Illinois.",
  h1: "Emergency & Expedited Passport Services in Decatur, IL",
  heroSubtitle: "ADM business trip to South America with a week's notice? Millikin University semester abroad and your passport's expiring? Lake Decatur summer Europe trip and forgot to renew? We help Decatur residents get their passports fast — as fast as 24 hours. A+ BBB rated registered State Dept. courier serving Macon County and Central Illinois.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Decatur%20Illinois%20scenic%20cityscape%20featuring%20Lake%20Decatur%20with%20sailboats%20and%20waterfront%20parks%2C%20historic%20downtown%20Decatur%20with%20Transfer%20House%20landmark%2C%20Macon%20County%20Courthouse%20architecture%2C%20ADM%20corporate%20headquarters%20skyline%2C%20Millikin%20University%20campus%2C%20central%20Illinois%20prairie%20landscape%2C%20golden%20hour%20warm%20light%20over%20the%20lake%2C%20professional%20Midwestern%20city%20photography&width=1800&height=700&seq=decatur-il-hero-001&orientation=landscape",
  heroImageAlt: "Decatur Illinois with Lake Decatur and Transfer House landmark at golden hour",
  geoPosition: "39.8403;-88.9548",
  geoPlacename: "Decatur, Illinois",
  lastModified: "2026-06-04",
  regionalAgency: {
    name: "Chicago Passport Agency",
    address: "230 S Dearborn St, Suite 380, Chicago, IL 60604",
    distance: "Approximately 3 hours northeast of Decatur via I-72 and I-55",
  },
  nearbyCitiesZips: [
    { name: "Decatur", zips: "62521, 62522, 62523, 62526" },
    { name: "Mount Zion", zips: "62549" },
    { name: "Forsyth", zips: "62535" },
    { name: "Maroa", zips: "61756" },
    { name: "Warrensburg", zips: "62573" },
    { name: "Argenta", zips: "62501" },
    { name: "Oreana", zips: "62554" },
    { name: "Macon", zips: "62544" },
    { name: "Cerro Gordo", zips: "61818" },
    { name: "Blue Mound", zips: "62513" },
    { name: "Clinton", zips: "61727" },
    { name: "Shelbyville", zips: "62565" },
    { name: "Taylorville", zips: "62568" },
    { name: "Springfield", zips: "62701, 62702, 62703, 62704" },
    { name: "Champaign", zips: "61820, 61821, 61822" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier to Chicago Passport Agency — 3 hours away but you skip the trip" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-building-2-line", title: "Agribusiness Travel Hub", desc: "Serving ADM, Tate & Lyle, and Caterpillar corporate travelers in Central Illinois" },
    { icon: "ri-mail-send-line", title: "Document Shipping", desc: "Ship from any UPS or FedEx in Decatur — no Chicago drive required" },
  ],
  internalLinks: [
    { name: "Expedited passport in Springfield, IL", route: "/springfield-il" },
    { name: "Emergency passport help in Champaign, IL", route: "/cities/champaign" },
    { name: "Urgent passport services in Bloomington, IL", route: "/cities/bloomington-il" },
    { name: "Illinois passport services overview", route: "/states/illinois" },
  ],
  fpcOfficeAddress: "230 S Dearborn St, Suite 380, Chicago, IL 60604",
  fpcOfficeNote: "Fast Passport Center serves Decatur, Illinois remotely via secure registered courier. Our registered couriers hand-deliver your documents to the Chicago Passport Agency (3 hours northeast via I-72 and I-55) — without you making the trip. Decatur residents can ship from any UPS or FedEx in Macon County.",
  fpcOfficeDistance: "Serving Decatur, Mount Zion, Forsyth, Maroa, Warrensburg, Argenta, Oreana, Macon, Cerro Gordo, Blue Mound, Clinton, Shelbyville, Taylorville, and all of Macon County and Central Illinois",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Decatur and Central Illinois. From the ADM corporate headquarters and the Lake Decatur waterfront to Millikin University and the historic Transfer House in downtown, from the family neighborhoods of Mount Zion and Forsyth to the agricultural communities of Macon County — we serve the entire Decatur region.",
  nearbyCitiesIntro: "We serve Decatur and all nearby communities including Mount Zion, Forsyth, Maroa, Warrensburg, Argenta, Oreana, Macon, Cerro Gordo, Blue Mound, Clinton, Shelbyville, and Taylorville. We also serve all Macon County and surrounding Central Illinois communities.",
  howItWorksIntro: "Most Decatur travelers complete everything online and ship documents overnight. No need to drive 3 hours to Chicago — our couriers handle the Chicago Passport Agency trip for you.",
  mistakesIntro: "Decatur is home to ADM's global headquarters with significant international business travel and a strong agricultural export community. Here are the most common passport mistakes we see from Macon County travelers.",
  testimonialsIntro: "Decatur travelers — from ADM executives and agribusiness professionals to Millikin students and Lake Decatur families — trust us when their departure is days away.",
  faqIntro: "Have questions about expedited passports in Decatur, IL? Here are the most common ones we hear from Central Illinois travelers.",
  statePageRoute: "/states/illinois",
  statePageName: "Illinois",
  dmvWebsite: "https://www.ilsos.gov/facilities/facilitylist.html",
  dmvLabel: "Illinois Secretary of State — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Chicago Passport Agency — hand-delivered", "No 6-hour round trip to Chicago required", "Perfect for ADM corporate travel and agribusiness", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Chicago Passport Agency — hand-delivered", "Faster than self-service", "Good for planned travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "No phone or email contact for your case", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins allowed", "Life-or-death emergencies only", "Must drive 3 hours to downtown Chicago", "Effectively a full day off work for the trip"],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Decatur travelers with immediate departure needs — as fast as 24 hours. Our couriers use the Chicago Passport Agency — 3 hours away but you never make the trip.",
      bullets: ["24–48 hour turnaround available", "Chicago Passport Agency direct courier", "Perfect for ADM international business emergencies"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for Decatur adults with a passport issued within the last 15 years. Skip the post office appointment entirely.",
      bullets: ["No clerk visit required for most renewals", "Mail-in or courier options", "Returned to your Decatur address"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport (First-Time)",
      description: "First-time passport application for Decatur residents — including first-time travelers, Millikin students, and young professionals.",
      bullets: ["Acceptance facility scheduling", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Emergency passport replacement for Decatur residents who lost their passport before international travel.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement in 24–48 hours"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 — for Decatur and Macon County families with kids traveling internationally.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change Passport",
      description: "Passport name correction after marriage, divorce, or legal name changes for Decatur and Macon County residents.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Decatur IL", description: "Urgent passport processing for Decatur Illinois travelers with immediate departure needs." },
    { name: "Expedited Passport Renewal Decatur IL", description: "Fast passport renewal for Decatur Illinois residents and ADM corporate travelers." },
    { name: "First-Time Passport Decatur IL", description: "New passport application services for Decatur Illinois residents." },
    { name: "Child Passport Decatur IL", description: "Minor passport services for Decatur Illinois families with children under 16." },
  ],
  testimonials: [
    {
      name: "Robert H.",
      location: "Decatur, IL",
      rating: 5,
      text: "ADM sent me to their Sao Paulo office on an emergency consultation with 5 days notice. My passport was expired. Fast Passport Center got my renewal in 28 hours. I shipped from the UPS on Pershing Road. Never left Decatur. This service is a game changer for agribusiness professionals.",
      service: "Emergency Passport Renewal",
    },
    {
      name: "Susan M.",
      location: "Mount Zion, IL",
      rating: 5,
      text: "Three passports for a family trip to Ireland — two adult renewals and a first-time for our teenager. Fast Passport Center got all three done in 4 days. The dedicated agent was incredible — walked us through every detail for the first-time application.",
      service: "Family Passport Bundle",
    },
    {
      name: "Kevin L.",
      location: "Forsyth, IL",
      rating: 5,
      text: "Tate & Lyle conference in London with 8 days notice and my passport was water damaged. Fast Passport Center replaced it in 32 hours. From Decatur to London in under a week — absolutely incredible. Saved my career opportunity.",
      service: "Damaged Passport Replacement",
    },
  ],
  facilities: [
    {
      id: "dcil-1",
      name: "Decatur Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "214 N Franklin St",
      city: "Decatur",
      state: "IL",
      zip: "62523",
      phone: "(217) 423-2921",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Downtown Decatur",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Decatur acceptance facility. Near downtown Decatur and the Transfer House. Appointments strongly recommended.",
      icon: "ri-mail-line",
    },
    {
      id: "dcil-2",
      name: "Macon County Clerk",
      type: "County Clerk Passport Acceptance",
      address: "141 S Main St, Room 104",
      city: "Decatur",
      state: "IL",
      zip: "62523",
      phone: "(217) 424-1369",
      hours: "Mon–Fri: 8:30 AM – 4:30 PM",
      distance: "Downtown Decatur, Macon County Office Building",
      website: "https://www.maconcounty.illinois.gov/",
      websiteLabel: "Macon County Clerk",
      notes: "County acceptance facility in historic downtown Decatur. Good alternative to post office. Call ahead to confirm passport acceptance hours.",
      icon: "ri-government-line",
    },
    {
      id: "dcil-3",
      name: "Mount Zion Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "155 S Henderson St",
      city: "Mount Zion",
      state: "IL",
      zip: "62549",
      phone: "(217) 864-3211",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Mount Zion, approximately 5 miles southeast of Decatur",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Mount Zion and southeastern Macon County. Convenient for Lake Decatur area residents.",
      icon: "ri-mail-line",
    },
    {
      id: "dcil-4",
      name: "Clinton Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "105 N Quincy St",
      city: "Clinton",
      state: "IL",
      zip: "61727",
      phone: "(217) 935-5111",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Clinton, approximately 20 miles northwest of Decatur",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves DeWitt County. Full passport acceptance services available.",
      icon: "ri-mail-line",
    },
    {
      id: "dcil-5",
      name: "Taylorville Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "300 S Main St",
      city: "Taylorville",
      state: "IL",
      zip: "62568",
      phone: "(217) 824-4811",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Taylorville, approximately 30 miles southwest of Decatur",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Christian County. Full passport acceptance services. Good option for southwestern Macon County residents.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, 2–3 week wait", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 3 hour drive to Chicago", fpc: "No — ship from Decatur" },
    { feature: "Time Off Work", agency: "Full day off — 6 hour round trip", fpc: "Minutes — ship from your neighborhood" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
  ],
  mistakes: [
    {
      icon: "ri-calendar-close-line",
      title: "ADM International Travel Urgency",
      description: "ADM's global headquarters in Decatur means frequent international business travel — often on short notice. Many executives discover expired passports days before departure. The 3-hour drive to Chicago makes a same-day agency visit unworkable.",
    },
    {
      icon: "ri-passport-line",
      title: "Six-Month Passport Validity Problem",
      description: "Agribusiness travelers to South America and Asia often face 6-month passport validity rules. Many Decatur business travelers assume 3 months is sufficient. Always check destination requirements well before travel.",
    },
    {
      icon: "ri-image-line",
      title: "Incorrect Passport Photos",
      description: "Local photo services in Decatur may not meet strict federal standards. Photos must be exactly 2x2 inches on a white background with proper head positioning. Use a service that guarantees passport compliance.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete or Wrong Forms",
      description: "Using DS-82 when you need DS-11 or vice versa causes immediate rejection. Missing signatures or old form versions also cause delays. Our document review catches these before submission.",
    },
    {
      icon: "ri-road-map-line",
      title: "Wasted Trip to Chicago Agency",
      description: "Decatur to Chicago is a 3-hour drive each way — a full workday lost. Then you still face downtown parking, long wait times, and no guarantee of same-day service. Our courier service eliminates all of this.",
    },
    {
      icon: "ri-bank-card-line",
      title: "Wrong Payment Method",
      description: "State Department fees require specific payment types at acceptance facilities. Many Decatur applicants arrive with credit cards when checks or money orders are required. Verify payment methods before your appointment.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes — from anywhere in Decatur or Macon County." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS or FedEx on Pershing Road or near downtown Decatur." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document — experienced with agribusiness corporate travel and family documentation." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Our registered courier submits to the Chicago Passport Agency — 3 hours away but you never make the trip." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Decatur address — trackable every step of the way." },
  ],
  faqs: [
    { q: "How fast can I get an emergency passport in Decatur, IL?", a: "Fast Passport Center offers emergency passport processing in Decatur, Illinois in as little as 24–48 hours. Our registered couriers hand-deliver your documents to the Chicago Passport Agency (3 hours northeast via I-72 and I-55) — without you making the trip. Perfect for ADM corporate travel emergencies." },
    { q: "Does Decatur have a passport agency?", a: "No — Decatur does not have a regional passport agency. The nearest facility is the Chicago Passport Agency approximately 3 hours northeast via I-72 and I-55. Fast Passport Center's courier service means Macon County residents never need to make the 6-hour round trip." },
    { q: "Can you help ADM and agribusiness travelers in Decatur?", a: "Absolutely. Fast Passport Center serves ADM, Tate & Lyle, Caterpillar, and all agribusiness and corporate travelers in Decatur. Our service is ideal for business professionals who need fast, reliable passport processing without taking a full day to drive to Chicago." },
    { q: "What airport do Decatur travelers use for international flights?", a: "Decatur Airport (DEC) offers limited regional services. For international flights, most Decatur travelers use Chicago O'Hare (ORD) — approximately 3 hours northeast via I-72 and I-55. St. Louis Lambert (STL) is approximately 2 hours 15 minutes south, and Indianapolis (IND) is approximately 2 hours 15 minutes east." },
    { q: "Do you serve Mount Zion, Forsyth, and Macon County communities?", a: "Yes — Fast Passport Center serves all of Decatur and Macon County including Mount Zion, Forsyth, Maroa, Warrensburg, Argenta, Oreana, Macon, Cerro Gordo, and Blue Mound. Our service works identically across the region." },
    { q: "Can I get my child's passport expedited in Decatur?", a: "Yes. Fast Passport Center expedites child passports in Decatur for minors under 16. Both parents must appear or submit notarized consent. We guide Macon County families through the entire DS-11 process." },
    { q: "Where can I get passport photos in Decatur?", a: "Walgreens on Pershing Road, CVS on Eldorado Street, and the UPS Store on Route 36 all offer passport photos. Photos must be 2x2 inches on a white background and taken within 6 months." },
    { q: "How much does an expedited passport cost in Decatur, IL?", a: "Government fees are fixed: $130 for a first-time adult passport book or $130 + $60 expedite fee for renewal. Fast Passport Center's service fees vary by processing speed. Contact us for a customized quote based on your departure timeline." },
  ],
  photoLocations: [
    { name: "Walgreens — Decatur", address: "3095 N Water St, Decatur, IL 62526", hours: "Mon–Sun: 7AM–10PM", website: "https://www.walgreens.com/photo" },
    { name: "UPS Store — Decatur", address: "1330 E Pershing Rd, Decatur, IL 62526", hours: "Mon–Fri: 8AM–7PM, Sat: 9AM–5PM", website: "https://www.theupsstore.com/print/passport-photos" },
    { name: "CVS — Decatur", address: "120 E Eldorado St, Decatur, IL 62523", hours: "Mon–Sun: 8AM–10PM", website: "https://www.cvs.com/photo" },
    { name: "Walmart Supercenter — Decatur", address: "4224 N Prospect Dr, Decatur, IL 62526", hours: "Mon–Sun: 7AM–11PM", website: "https://www.walmart.com/cp/photo/1078904" },
  ],
  dmvLocations: [
    { name: "Illinois SOS — Decatur", address: "3149 N Woodford St, Decatur, IL 62526", hours: "Mon–Fri: 8:00AM–5:00PM", note: "Illinois Secretary of State for driver's licenses, REAL ID, and vehicle registration. Near I-72 in northern Decatur. Online reservations strongly recommended.", featured: true },
    { name: "Illinois SOS — Clinton", address: "220 W Washington St, Clinton, IL 61727", hours: "Mon–Fri: 8:00AM–5:00PM", note: "Serves DeWitt County and western Macon County. REAL ID processing available.", featured: false },
  ],
  vitalRecordsIcon: "ri-heart-pulse-line",
  vitalRecordsLinks: [
    { label: "Birth & Death Certificates (IDPH)", url: "https://dph.illinois.gov/topics-services/birth-death-other-records.html", desc: "Illinois Department of Public Health — Division of Vital Records for Macon County birth and death certificates" },
    { label: "Marriage Licenses (Macon County Clerk)", url: "https://www.maconcounty.illinois.gov/departments/county-clerk/", desc: "Macon County Clerk — marriage license applications and certified copies for Decatur and surrounding areas" },
    { label: "Divorce Decrees (Macon County Circuit Clerk)", url: "https://www.maconcounty.illinois.gov/departments/circuit-clerk/", desc: "Macon County Circuit Clerk — divorce decree records for Decatur and Macon County residents" },
    { label: "VitalChek Online Ordering", url: "https://www.vitalchek.com/", desc: "Order Illinois birth, death, marriage, and divorce certificates online via VitalChek — fastest state-approved method" },
  ],
  airports: [
    {
      code: "DEC",
      name: "Decatur Airport",
      distance: "Approximately 5 miles east of downtown Decatur",
      address: "910 S Airport Rd, Decatur, IL 62521",
      note: "Regional airport serving Decatur. Limited commercial service — primarily general aviation and corporate flights. ADM and other companies use this airport for corporate aviation.",
      flightUrl: "https://www.decatur-parks.org/airport/",
      flightLabel: "DEC Airport Info",
      featured: true,
    },
    {
      code: "STL",
      name: "St. Louis Lambert International Airport",
      distance: "Approximately 2 hours 15 minutes southwest via I-72 and I-55",
      address: "10701 Lambert International Blvd, St. Louis, MO 63145",
      note: "Major airport with Southwest Airlines hub and international flights. Often the preferred international gateway for Decatur residents heading south or west.",
      flightUrl: "https://www.flystl.com/",
      flightLabel: "STL Flight Info",
      featured: false,
    },
    {
      code: "ORD",
      name: "Chicago O'Hare International Airport",
      distance: "Approximately 3 hours northeast via I-72 and I-55",
      address: "10000 W O'Hare Ave, Chicago, IL 60666",
      note: "One of the world's busiest airports with global flights to every continent. United and American Airlines hub. Longer drive but most international route options.",
      flightUrl: "https://www.flychicago.com/ohare/",
      flightLabel: "ORD Flight Info",
      featured: false,
    },
  ],
};